import * as API from "../../api"
import * as ActionTypes from "../action-types";

/**
 * ThirdParty Library
 */
import {
    message
} from 'antd'

/**
 * 
 * Redux Action
 */
import {
    get_vehicle_groups_request,
    // get_vehicles_by_vehicle_group_relation_request
} from './vehicleGroups'
import {
    get_device_groups_request,
    // get_devices_by_device_group_relation_request
} from './deviceGroups'
import {
    get_driver_groups_request
} from './driverGroups'
import {
    get_geofence_templates_request
} from './geofenceTemplates'
import {
    setLoadingUser,
    unsetLoadingUser,
    setLoadingHierUser,
    unsetLoadingHierUser
} from './style'

/**
 * Main User Get Hierarchy Profile 
 */

export const user_hierarchy_get_request = (user, hierCode) => dispatch => {

    dispatch(setLoadingHierUser())

    API.getUserHierarchy(hierCode)
        .then(data => {
            if (data.status !== 200) {
                message.error('Error at get_user_hierarchy', data.message)
            }
            else {

                dispatch(user_hierarchy_get_success(user, data))

                const {
                    allIDs
                } = data

                allIDs && allIDs.map(uid => uid !== user.uid && setTimeout(() => dispatch(hierarchial_user_info_get_request(uid)), 0))

            }
        })
        .finally(() => {
            dispatch(unsetLoadingHierUser())
        })
}

const user_hierarchy_get_success = (user, data) => {
    return {
        type: ActionTypes.GET_USER_HIERARCHY,
        user,
        hierarchyTree: data.hierarchyTree,
        allIDs: data.allIDs
    }
}

/**
 * Hierarchical User Info Get 
 */

export const hierarchial_user_info_get_request = (uid) => dispatch => {

    API
    // .getInfoByUser(uid, 1)
    .getInfoByUser(uid)
    .then(info => {
        try {
            const {
                asset,
                user
            } = info

            const {
                devgids,
                vhcgids,
                geotids,
                drvgids
            } = asset

            dispatch(hierarchial_user_info_get_success(user))

            if(vhcgids) {
                dispatch(get_vehicle_groups_request(vhcgids, uid))
                // dispatch(get_vehicles_by_vehicle_group_relation_request(vhcgids, uid))
            }
            if(devgids) {
                dispatch(get_device_groups_request(devgids, uid))
                // dispatch(get_devices_by_device_group_relation_request(devgids, uid))
            }
            if(drvgids) dispatch(get_driver_groups_request(drvgids, uid))
            if(geotids) dispatch(get_geofence_templates_request(geotids, uid))


        } catch(err) {
            message.error('Error. Refresh page?')
        }
    })

}

const hierarchial_user_info_get_success = (user) => {
    return {
        type: ActionTypes.GET_HIERARCHIAL_USER_INFO,
        user
    };
}

/**
 * Set Selected User
 */

export const set_selected_user_for_hierarchy_request = (uid) => dispatch => {
    dispatch(set_selected_user_for_hierarchy_success(uid))
}

const set_selected_user_for_hierarchy_success = (uid) => {
    return {
        type: ActionTypes.SET_SELECTED_USER_FOR_USER_HIERARCHY,
        uid
    }
}

export const unset_selected_user_for_hierarchy_request = () => dispatch => {
    dispatch(unset_selected_user_for_hierarchy_success())
}

const unset_selected_user_for_hierarchy_success = () => {
    return {
        type: ActionTypes.UNSET_SELECTED_USER_FOR_USER_HIERARCHY
    }
}

export const user_profile_create_request = (items, cb = () => {}) => dispatch => {

    dispatch(setLoadingUser())

    API
    .cuUser({
        action: 'C',
        ...items
    })
    .then(info => {
        
        const { user, hierarchyTree, status, msg } = info
        
        if(status === 200) {
            user && dispatch(user_profile_create_success(user, hierarchyTree))
            cb()
        } else if(status === 401) {
            message.warning(`Failed in creating user. ${msg}`)
        } else {
            message.warning(`Failed in creating user. Retry?`)
        }

    })
    .finally(() => {
        dispatch(unsetLoadingUser())
    })
}

const user_profile_create_success = (user, hierarchyTree) => {
    return {
        type: ActionTypes.USER_PROFILE_CREATE,
        user,
        hierarchyTree
    };
}


export const user_profile_update_request = (items, cb = () => {}) => dispatch => {

    dispatch(setLoadingUser())

    API
    .cuUser({
        action: 'U',
        ...items
    })
    .then(info => {
        
        const { status, msg } = info
        
        if(status === 200) {
            // dispatch(user_profile_update_success({ ...items.userInfo, ...user }))
            // dispatch(hierarchial_user_info_get_request(user.uid))
            cb()
        } else if(status === 401) {
            message.warning(`Failed in updating user. ${msg}`)
        } else {
            message.warning(`Failed in updating user. Retry?`)
        }
    })
    .finally(() => {
        dispatch(unsetLoadingUser())
    })
}

// const user_profile_update_success = (user) => {
//     return {
//         type: ActionTypes.USER_PROFILE_UPDATE,
//         user
//     };
// }